export const SCHEDULE_TYPES = {
  FIELD: 'Field',
  PULLIN: 'Pullin',
  DROPOFF: 'Dropoff',
  ORDER_LINE: 'OrderLine',
};
